import { render, staticRenderFns } from "./SampleMailInfo.vue?vue&type=template&id=bf477cc8&scoped=true&"
import script from "./SampleMailInfo.vue?vue&type=script&lang=js&"
export * from "./SampleMailInfo.vue?vue&type=script&lang=js&"
import style0 from "./SampleMailInfo.vue?vue&type=style&index=0&id=bf477cc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf477cc8",
  null
  
)

export default component.exports